import { Container, Dialog, DialogContent } from "@material-ui/core";
import React, { memo, useEffect, useState } from "react";
import API from "../../API";
import ReactPlayer from "react-player";
import { CloseOutlined, PlayArrowTwoTone } from "@material-ui/icons";

import "./video-guide.css";

export default memo(props => {
    const [SasToken, setSasToken] = useState("");
    const [popUp, setPopUp] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const fetchSas = async () => {
        const { sasToken } = await API.getSASTokenForVideoGuide();
        setSasToken(sasToken);
    };
    const videosArray = [
        {
            name: "Hvordan du laver en samlefaktura",
            url: "https://handsonbooking.blob.core.windows.net/guide-static-video-container/handson_booking_guide_til_samlefakturaer-1726130668219.mp4",
            imgUrl: "https://handsonbooking.blob.core.windows.net/guide-static-video-container/thumbnail_handson_booking_guide_til_samlefakturaer-1726130668219.png"
        },
        {
            name: "Hvordan du uploader billeder til patientjournaler",
            url: "https://handsonbooking.blob.core.windows.net/guide-static-video-container/handson_booking_billede_upload_guide.mp4",
            imgUrl: "https://handsonbooking.blob.core.windows.net/guide-static-video-container/handson_image_upload_guide_thumbnail.png"
        }
    ];
    // const url =
    //     "https://handsonbooking.blob.core.windows.net/guide-static-video-container/handson_booking_guide_til_samlefakturaer-1726130668219.mp4";
    // const imgUrl =
    //     "https://handsonbooking.blob.core.windows.net/guide-static-video-container/thumbnail_handson_booking_guide_til_samlefakturaer-1726130668219.png";
    useEffect(() => {
        fetchSas();
    }, []);
    props.setLocationName();
    return (
        <Container style={{ overflowY: "auto", padding: true ? "10px" : "0px", height: "100%" }}>
            <div
                container
                style={{
                    marginTop: "5px",
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(358px, 1fr))",
                    gap: "30px"
                }}>
                {videosArray.map((item, index) => {
                    return (
                        <div key={index}>
                            <div
                                style={{
                                    backgroundColor: "white",
                                    boxShadow:
                                        "0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 2px -1px rgba(0, 0, 0, 0.02)",
                                    padding: "10px",
                                    borderRadius: "2px",
                                    margin: "2px"
                                }}>
                                {SasToken && (
                                    <>
                                        <p style={{ margin: "2px 0", fontSize: "1.2rem" }}>{item.name}</p>
                                        <div style={{ position: "relative" }}>
                                            <img
                                                src={`${item.imgUrl}?${SasToken}`}
                                                style={{ width: "100%", border: "1px solid blue", borderRadius: "2px" }}
                                            />
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "0",
                                                    left: "0",
                                                    right: "0",
                                                    bottom: "0",
                                                    height: "96%",
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}>
                                                <PlayArrowTwoTone
                                                    style={{
                                                        height: "30%",
                                                        width: "30%",
                                                        cursor: "pointer",
                                                        fill: "blue"
                                                    }}
                                                    onClick={() => {
                                                        setPopUp(true);
                                                        setVideoUrl(item.url);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div style={{ padding: "10px", borderRadius: "2px", margin: "2px" }}></div>
                            <div style={{ padding: "10px", borderRadius: "2px", margin: "2px" }}></div>
                        </div>
                    );
                })}
            </div>

            <Dialog
                open={popUp}
                onClose={() => setPopUp(false)}
                PaperProps={{
                    style: {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        maxWidth: "80%"
                    }
                }}>
                <DialogContent
                    style={{
                        display: "flex",
                        position: "relative",
                        width: "100%",
                        maxWidth: "900px",
                        padding: "24px",
                        margin: "0px auto"
                    }}>
                    <ReactPlayer playing controls url={`${videoUrl}?${SasToken}`} height={"unset"} width={"100%"} />
                    <CloseOutlined
                        style={{
                            position: "absolute",
                            top: "0px",
                            right: "0px",
                            color: "white",
                            cursor: "pointer"
                        }}
                        onClick={() => setPopUp(false)}
                    />
                </DialogContent>
            </Dialog>
        </Container>
    );
});
